import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '../index';

const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
}).lazy(() => import('../../ui/page/PageHome').then(d => d.Route));

const productsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/products',
}).lazy(() => import('../../ui/page/PageProducts').then(d => d.Route));

const contactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/contact',
}).lazy(() => import('../../ui/page/PageContact').then(d => d.Route));

export { homeRoute, productsRoute, contactRoute };
